import React from 'react';
import { publicRequest } from '../../Helpers/RequestHelper';
import { t } from 'i18next';
import { setObjInLS } from '../../Helpers/LocalStorage';

class UserConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
    };
  }

  componentDidMount() {
    // If URL contains a package_id query, store it in session/local storage  
      if (window && window.location && window.location.search) {
        const params = new URLSearchParams(window.location.search);
        
        const pkg = params.get('package_id') || params.get('package_id') || params.get('packageid') || params.get('Axtjhgts09874kch');
        const fallback = window.location.search.split('=')[1];
        if (pkg || fallback) {
          setObjInLS('package_id', atob(pkg) || fallback);
        }
      }
    publicRequest('post', 'register/confirm', {
      register_confirm_token: this.props.match.params.token,
    })
      .then((res) => {
        if (res.hasOwnProperty('msg')) {
          this.props.handleToast(res.msg, 'success');
        } else {
          this.props.handleToast(
            t('common.account_confirmed_successfully'),
            'success'
          );
        }
        this.props.history.push('/login');
      })
      .catch((error) => {
        this.props.handleToast(error, 'error');
      });
  }

  confirmComponent() {
    return (
      <div className="container">
        <div className="row">
          <div className="panel panel-warning text-center">
            <div className="panel-heading">
              <h4>Verifying your account ...</h4>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return <div>{this.confirmComponent()}</div>;
  }
}

export default UserConfirmation;
